<template>
  <div>
    <transition name="form-show" mode="out-in">
      <projects-tiles v-if="isTile"
                    :projects="projects"></projects-tiles>
    </transition>
    <transition name="form-show" mode="out-in">
      <projects-list v-if="isList"
                     :projects="projects"></projects-list>
    </transition>
  </div>
</template>

<script>
  import {mapState,mapMutations} from 'vuex'
  import projectsTiles from './projectsTiles'
  import projectsList from './projectsList'
  import {projectsView} from "../../../mixins/projects/projectsView";

  export default {
    name: 'projectsBody',
    mixins: [projectsView],
    components: {
      projectsList,
      projectsTiles
    },
    computed: {
      ...mapState({
        projects: state => state.projects.allProjects
      })
    },
    methods: {

    }
  }
</script>
